<template>
  <v-app-bar class="app-bar px-4" elevation="0">

    <!-- Search -->
    <v-app-bar-title>
      <div class="search-wrap">
        <v-text-field
          placeholder="Search..."
          :color="$vuetify.theme.themes.light.inputColor"
          variant="outlined"
          density="compact"
          rounded="lg"
          hide-details
          prepend-inner-icon="mdi-magnify"
        />
      </div>
    </v-app-bar-title>

    <v-spacer />

    <!-- ── Notification bell ── -->
    <NotificationDropdown />

    <!-- ── Avatar + user menu ── -->
    <v-menu
      v-model="userMenuOpen"
      location="bottom end"
      :close-on-content-click="true"
      transition="scale-transition"
      offset="8"
    >
      <template #activator="{ props }">
        <div v-bind="props" class="avatar-trigger">
          <div class="avatar-circle">{{ userInitial }}</div>
          <v-icon size="16" color="#6b7280">
            {{ userMenuOpen ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
          </v-icon>
        </div>
      </template>

      <div class="user-menu">

        <!-- Name + role -->
        <div class="user-menu-header">
          <div class="user-menu-name">{{ userName }}</div>
          <div class="user-menu-role">{{ userRole }}</div>
        </div>

        <v-divider />

        <!-- Settings -->
        <div class="user-menu-item" @click="goToSettings">
          <v-icon size="18" color="#6b7280">mdi-cog-outline</v-icon>
          <span>Settings</span>
        </div>

        <v-divider />

        <!-- Sign out -->
        <div class="user-menu-item user-menu-item--danger" @click="logoutUser">
          <v-icon size="18" color="#ef4444">mdi-logout-variant</v-icon>
          <span>Sign Out</span>
        </div>

      </div>
    </v-menu>

  </v-app-bar>
</template>

<script>
import NotificationDropdown from "./NotificationDropdown.vue";

const ROLE_MAP = {
  1: "Superadmin",
  2: "Admin",
  4: "Instructor",
  5: "Dean",
  6: "VPAA",
  7: "HTE Organization",
  8: "Student",
  9: "Field Officer",
  10: "Program Chairperson",
};

const USER_TYPE_PATH = {
  1: "superadmin",
  2: "admin",
  3: "ojt-coordinator",
  4: "instructor",
  5: "dean",
  6: "vpaa",
  7: "organization",
  8: "student",
  9: "field-officer",
  10: "program-chair",
};

export default {
  components: { NotificationDropdown },

  data: () => ({
    userMenuOpen: false,
  }),

  computed: {
    userState() {
      return this.$store.state.user;
    },
    userTypeId() {
      return this.userState?.user?.usertypeID;
    },
    userName() {
      if (this.userTypeId == 7) return this.userState?.name || "";
      if (this.userTypeId == 9) return this.userState?.officer_name || "";
      const { fname, lname } = this.userState || {};
      return [fname, lname].filter(Boolean).join(" ");
    },
    userInitial() {
      return (this.userName?.[0] || "?").toUpperCase();
    },
    userRole() {
      if (this.userTypeId == 3) {
        const active = this.$store.getters.getActiveRole;
        return active == 1 ? "OJT Coordinator" : "Instructor";
      }
      return ROLE_MAP[this.userTypeId] || "";
    },
    userTypePath() {
      return USER_TYPE_PATH[this.userTypeId] || "student";
    },
  },

  methods: {
    logoutUser() {
      this.logout();
      location.reload();
    },
    goToSettings() {
      this.$router.push(`/${this.userTypePath}/change-creds`);
    },
  },
};
</script>

<style scoped>
.app-bar {
  border-bottom: 1px solid #e5e7eb !important;
  background: #ffffff !important;
}

/* Search */
.search-wrap {
  width: 260px;
}

/* ── Avatar trigger ── */
.avatar-trigger {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  padding: 4px 6px;
  border-radius: 10px;
  transition: background 0.15s;
  margin-left: 4px;
}

.avatar-trigger:hover {
  background: #f1f5f9;
}

.avatar-circle {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #d1fae5;
  color: #065f46;
  font-size: 14px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

/* ── User dropdown panel ── */
.user-menu {
  width: 230px;
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #E2E8F0;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  overflow: hidden;
}

.user-menu-header {
  padding: 16px 18px 14px;
}

.user-menu-name {
  font-size: 15px;
  font-weight: 700;
  color: #111827;
  line-height: 1.3;
}

.user-menu-role {
  font-size: 13px;
  color: #64748b;
  margin-top: 2px;
}

.user-menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 18px;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  cursor: pointer;
  transition: background 0.12s;
}

.user-menu-item:hover {
  background: #f8fafc;
}

.user-menu-item--danger {
  color: #ef4444;
}

.user-menu-item--danger:hover {
  background: #fff1f2;
}
</style>
